import React from "react";

import { useTranslation, Trans } from "react-i18next";

function OurClients () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative pt-[80px] xl:pt-[160px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
               <p className="text-[30px] xl:text-[40px] italic font-[700] merriweather text-center"><Trans>{t('account.35')}</Trans></p>
               <div className="grid grid-cols-1 sm:grid-cols-3 mt-[50px] xl:mt-[65px] gap-y-[30px]">
                    <div className="flex flex-col items-center">
                        <p className="text-[18px] xl:text-[30px] italic font-[700] merriweather text-center"><Trans>{t('account.36')}</Trans></p>
                        <p className="inter text-[14px] xl:text-[16px] font-[300] fdfd"><Trans>{t('account.37')}</Trans></p>
                    </div>
                    <div className="flex flex-col items-center">
                        <p className="text-[18px] xl:text-[30px] italic font-[700] merriweather text-center"><Trans>{t('account.38')}</Trans></p>
                        <p className="inter text-[14px] xl:text-[16px] font-[300] fdfd"><Trans>{t('account.39')}</Trans></p>
                    </div>
                    <div className="flex flex-col items-center">
                        <p className="text-[18px] xl:text-[30px] italic font-[700] merriweather text-center"><Trans>{t('account.40')}</Trans></p>
                        <p className="inter text-[14px] xl:text-[16px] font-[300] fdfd"><Trans>{t('account.41')}</Trans></p>
                    </div>
               </div>
            </div>
        </div>
    );
}

export default OurClients;